// extracted by mini-css-extract-plugin
export default {"brandPromo":"gK-z","carousel":"hK-z"};